"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.billingTierCatalog = exports.packageCatalog = exports.LEGACY_PACKAGE_SLUG_ALIASES = exports.normalizePackageSlug = exports.PRO_PACKAGE_SLUG = exports.PACKAGE_BILLING_STEP_OPTIONS = exports.PACKAGE_BILLING_STEP_MAX = exports.PACKAGE_BILLING_STEP_MIN = exports.normalizePackageTone = exports.PACKAGE_TONE_OPTIONS = exports.PACKAGE_TONES = void 0;
exports.formatPackageBillingStep = formatPackageBillingStep;
exports.sortedPackageBillingSteps = sortedPackageBillingSteps;
exports.groupPackagesByBillingStep = groupPackagesByBillingStep;
exports.getPackageBySlug = getPackageBySlug;
const package_features_1 = require("./package-features");
var package_theme_1 = require("./package-theme");
Object.defineProperty(exports, "PACKAGE_TONES", { enumerable: true, get: function () { return package_theme_1.PACKAGE_TONES; } });
Object.defineProperty(exports, "PACKAGE_TONE_OPTIONS", { enumerable: true, get: function () { return package_theme_1.PACKAGE_TONE_OPTIONS; } });
Object.defineProperty(exports, "normalizePackageTone", { enumerable: true, get: function () { return package_theme_1.normalizePackageTone; } });
exports.PACKAGE_BILLING_STEP_MIN = 1;
exports.PACKAGE_BILLING_STEP_MAX = 8;
exports.PACKAGE_BILLING_STEP_OPTIONS = Array.from({ length: exports.PACKAGE_BILLING_STEP_MAX - exports.PACKAGE_BILLING_STEP_MIN + 1 }, (_, i) => exports.PACKAGE_BILLING_STEP_MIN + i);
function formatPackageBillingStep(step) {
    return `Κατηγορία ${step}`;
}
function sortedPackageBillingSteps(packages) {
    return [...new Set(packages.map((p) => p.billingStep))].sort((a, b) => a - b);
}
function groupPackagesByBillingStep(packages) {
    var _a;
    const map = new Map();
    for (const pkg of packages) {
        const list = (_a = map.get(pkg.billingStep)) !== null && _a !== void 0 ? _a : [];
        list.push(pkg);
        map.set(pkg.billingStep, list);
    }
    return map;
}
exports.PRO_PACKAGE_SLUG = 'basic';
var package_features_2 = require("./package-features");
Object.defineProperty(exports, "normalizePackageSlug", { enumerable: true, get: function () { return package_features_2.normalizePackageSlug; } });
Object.defineProperty(exports, "LEGACY_PACKAGE_SLUG_ALIASES", { enumerable: true, get: function () { return package_features_2.LEGACY_PACKAGE_SLUG_ALIASES; } });
exports.packageCatalog = [
    {
        slug: exports.PRO_PACKAGE_SLUG,
        name: 'Basic',
        tone: 'violet',
        billingStep: 1,
        billingSelectionMode: 'exclusive',
        billingPriceKey: 'basic',
        priceMonthlyCents: 1200,
        priceAnnualCents: 12000,
        priceMonthlyInitialCents: null,
        priceAnnualInitialCents: null,
        includesSlugs: [],
        featureKeys: (0, package_features_1.defaultFeatureKeysForSlug)('basic'),
        maxAiOffers: null,
        offerRegenLimit: 4,
        stage: 'AI Προσφορές',
        description: 'AI προσφορές για επαγγελματίες που θέλουν να στέλνουν γρήγορα και επαγγελματικά offers.',
        plainSummary: 'Από σημειώσεις σε επαγγελματική προσφορά σε λεπτά.',
        features: [
            'Στέλνεις επαγγελματικές προσφορές σε λεπτά',
            'AI από σημειώσεις, φωνή ή φωτογραφία',
            'WhatsApp, Viber, email ή PDF',
            'Βασικό CRM πελατών',
            'Web + mobile app',
        ],
        detailTitle: 'Για καθημερινές προσφορές χωρίς χάσιμο χρόνου',
        detailIntro: 'Το Basic είναι το entry package: γράφεις, υπαγορεύεις ή σκανάρεις σημειώσεις και το ProfferAI φτιάχνει καθαρή προσφορά που στέλνεις αμέσως.',
        supports: [
            'Capture wizard: γραφή, υπαγόρευση ή OCR από φωτογραφία.',
            'Επεξεργασία προσφοράς και επαναδημιουργία κειμένου AI.',
            'CRM: πελάτες, στάδια pipeline, tags και εργασίες.',
            'Αποστολή με WhatsApp, Viber, email ή PDF.',
            'Web και εφαρμογή κινητού — ίδιες δυνατότητες παντού.',
        ],
        examples: [
            {
                profession: 'Ηλεκτρολόγος',
                title: 'Από φωνητική σημείωση σε έτοιμη προσφορά',
                steps: [
                    'Μετά την επίσκεψη λέει στο κινητό: αλλαγή πίνακα, 12 ασφάλειες, ρελέ διαρροής, εργασία και υλικά.',
                    'Το AI φτιάχνει καθαρή προσφορά — αν χρειάζεται, προσθέτει οδηγία και ξαναφτιάχνει το κείμενο.',
                    'Διορθώνει το ποσό, στέλνει WhatsApp, Viber ή email και κατεβάζει PDF.',
                ],
            },
            {
                profession: 'Υδραυλικός',
                title: 'Γρήγορη προσφορά μετά από αυτοψία',
                steps: [
                    'Γράφει λίγες σημειώσεις για αντικατάσταση θερμοσίφωνα, υλικά και χρόνο εργασίας.',
                    'Το ProfferAI οργανώνει το κείμενο ώστε να φαίνεται επαγγελματικό.',
                    'Ο πελάτης παίρνει άμεσα την προσφορά χωρίς να περιμένει χειρόγραφο.',
                ],
            },
        ],
        ctaLabel: 'Κάνε Εγγραφή',
    },
    {
        slug: 'pro',
        name: 'Pro',
        tone: 'emerald',
        billingStep: 1,
        billingSelectionMode: 'exclusive',
        billingPriceKey: 'pro',
        priceMonthlyCents: 2400,
        priceAnnualCents: 24000,
        priceMonthlyInitialCents: null,
        priceAnnualInitialCents: null,
        includesSlugs: ['basic'],
        featureKeys: (0, package_features_1.defaultFeatureKeysForSlug)('pro'),
        maxAiOffers: null,
        offerRegenLimit: 15,
        stage: 'Οργάνωση & Follow-up',
        description: 'Οργάνωση πελατών, follow-up και επαγγελματική παρουσία — για σοβαρούς επαγγελματίες.',
        plainSummary: 'Όλοι οι πελάτες και τα follow-up οργανωμένα σε ένα μέρος.',
        features: [
            'Όλα του Basic',
            'Δεν χάνεις ποτέ ξανά follow-up',
            'Link αποδοχής & timeline προσφορών',
            'Δημόσιο προφίλ & portfolio',
            'Ραντεβού & υπενθυμίσεις',
        ],
        detailTitle: 'Για να μη χάνεις δουλειές μετά την αποστολή',
        detailIntro: 'Το Pro συνδυάζει οργάνωση πελατών, follow-up, δημόσιο προφίλ και όλα τα εργαλεία κλεισίματος δουλειών.',
        supports: [
            'Ημερολόγιο ραντεβού και επερχόμενα στην αρχική.',
            'Link αποδοχής/απόρριψης και timeline προσφοράς.',
            'Follow-up email, templates και υπενθυμίσεις.',
            'Δημόσιο προφίλ, portfolio έργων, αξιολογήσεις και QR sharing.',
            'Έξοδα, margin και προχωρημένο CRM.',
        ],
        examples: [],
        marketingBadge: 'Most Popular',
        featured: true,
        ctaLabel: 'Κάνε Εγγραφή',
    },
    {
        slug: 'business',
        name: 'Business',
        tone: 'gold',
        billingStep: 1,
        billingSelectionMode: 'exclusive',
        billingPriceKey: 'business',
        priceMonthlyCents: 3900,
        priceAnnualCents: 39000,
        priceMonthlyInitialCents: null,
        priceAnnualInitialCents: null,
        includesSlugs: ['basic', 'pro'],
        featureKeys: (0, package_features_1.defaultFeatureKeysForSlug)('business'),
        maxAiOffers: null,
        offerRegenLimit: 50,
        stage: 'Reports & Κερδοφορία',
        description: 'Reports, analytics και κερδοφορία για επαγγελματίες και συνεργεία.',
        plainSummary: 'Πάρε αποφάσεις με πραγματικά δεδομένα και margin ανά έργο.',
        features: [
            'Όλα του Pro',
            'Ξέρεις ποιες δουλειές αφήνουν πραγματικό κέρδος',
            'Analytics dashboard & funnel',
            'Margin reports ανά έργο',
            'Εξαγωγές CSV/PDF',
        ],
        detailTitle: 'Για συνεργεία, εργολάβους και power users',
        detailIntro: 'Το Business δίνει πλήρη εικόνα κερδοφορίας, αναφορές και εξαγωγές για αποφάσεις με δεδομένα.',
        supports: [
            '9 ενότητες αναφορών: pipeline, CRM funnel, follow-up, οικονομικά.',
            'Widget στατιστικών στην αρχική και performance insights.',
            'Margin ανά έργο και οικονομικές αναφορές.',
            'Εξαγωγές CSV/PDF και executive summary.',
            'Πλήρης πρόσβαση από web και κινητό.',
        ],
        examples: [],
        ctaLabel: 'Κάνε Εγγραφή',
    },
];
exports.billingTierCatalog = exports.packageCatalog.filter((p) => p.slug !== exports.PRO_PACKAGE_SLUG);
function getPackageBySlug(slug) {
    var _a;
    if (!slug)
        return null;
    const normalized = (0, package_features_1.normalizePackageSlug)(slug);
    return (_a = exports.packageCatalog.find((pkg) => pkg.slug === normalized)) !== null && _a !== void 0 ? _a : null;
}
